import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PointOfSale } from '../../models/point-of-sale.model';
import { List } from '../../models/list.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class PosService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);
  baseURL = this.configService.readConfig().baseUrlInfrastructure;

  getPointOfSales(params: {
    page: number;
    pageSize: number;
    sort: string;
    sortDirection: string;
    filters?: string[];
  }): Observable<List<PointOfSale>> {
    let listUrl =
      this.baseURL +
      '/PointOfSales' +
      `?PageSize=${params.pageSize}&PageNumber=${params.page}&Sort=${params.sort}&SortDirection=${params.sortDirection}`;

    if (params.filters && params.filters.length > 0) {
      listUrl += `&Filter=${params.filters.join('&Filter=')}`;
    }
    return this.http.get<List<PointOfSale>>(listUrl);
  }

  getPointOfSalesById(id: number): Observable<PointOfSale> {
    const getUrl = this.baseURL + '/PointOfSales/' + id;
    return this.http.get<PointOfSale>(getUrl);
  }

  createPointOfSale(pointOfSale: PointOfSale): Observable<PointOfSale> {
    const createUrl = this.baseURL + '/PointOfSales';
    return this.http.post<PointOfSale>(createUrl, pointOfSale);
  }

  deletePointOfSale(pointOfSaleId: number): Observable<any> {
    const deleteUrl = this.baseURL + '/PointOfSales/' + pointOfSaleId;
    return this.http.delete(deleteUrl);
  }

  updatePointOfSale(pointOfSale: PointOfSale): Observable<PointOfSale> {
    const updateUrl = this.baseURL + '/PointOfSales/';
    return this.http.put<PointOfSale>(updateUrl, pointOfSale);
  }
}
